<template>
  <div
    v-if="message"
    class="alert alert-error flex justify-between items-center"
  >
    <p class="alert-text">
      {{ message }}
    </p>
    <button
      v-if="dismissible"
      @click="close"
      type="button"
    >
      <XIcon class="w-6 h-6 text-red-600" />
    </button>
  </div>
</template>

<script>
import { XIcon } from '@heroicons/vue/solid'

export default {
  components: {
    XIcon
  },
  props: {
    message: {
      type: String,
      default: null
    },
    dismissible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>
